/**
 * Feature available
 */
export const AVAILABLE = 'available';

/**
 * Feature unavailable
 */
export const UNAVAILABLE = 'unavailable';

/**
 * For legal reasons user should activate recall before use it. This type indicates
 * that user not activated recall yet
 */
export const ELIGIBLE = 'eligible';

/**
 * Upsell available
 */
export const SUBSCRIBABLE = 'subscribable';
